import {css} from '@emotion/css';
import React, {HTMLAttributes} from 'react';
import {theme} from './Common';

export type PageComponentProps = {page: number | string} & ContainerProps;
type ContainerProps = {isActive?: boolean} & HTMLAttributes<HTMLDivElement>;

export const Page = ({page, ...rest}: PageComponentProps) => (
  <Container {...rest}>{page}</Container>
);
const Container = ({isActive, className, ...rest}: ContainerProps) => (
  <div
    className={css({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: isActive ? '50px' : '40px',
      height: isActive ? '50px' : '40px',
      background: isActive ? theme.colors.darkBlue : 'transparent',
      color: isActive ? theme.colors.white : theme.colors.darkGray,
      fontSize: theme.font.sizes.medium,
      fontWeight: theme.font.medium,
      fontFamily: theme.font.family,
      cursor: 'pointer',
      padding: theme.spacings.xxsmall,
      [theme.mediaMaxWidth.medium]: {
        fontSize: theme.font.sizes.small,
        padding: `calc(${theme.spacings.xxsmall}/2)`,
        minWidth: isActive ? '40px' : '30px',
        height: isActive ? '40px' : '30px',
      },
    })}
    {...rest}
  />
);
